import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_ADMIN_USER_ROLES,
  CREATE_ADMIN_USER_ROLE,
  UPDATE_ADMIN_USER_ROLE,
  DELETE_ADMIN_USER_ROLE,
  ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE
} from "./actionTypes"

import {
  getAdminUserRolesSuccess,
  getAdminUserRolesError,
  updateAdminUserRolesSuccess,
  updateAdminUserRolesError,
  createAdminUserRolesSuccess,
  createAdminUserRolesError,
  deleteAdminUserRolesSuccess,
  deleteAdminUserRolesError,
  getAdminUserRoles,
  addNotificationTemplateToAdminRoleSuccess,
  addNotificationTemplateToAdminRoleError,
} from "./actions"

import { genericDeleteRequest, genericGetRequest, genericPostRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetAdminUserRoles() {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_roles`,
      {}, // no query parameters
      {
        Authorization: user.token,
      }
    )
    yield put(getAdminUserRolesSuccess(response))
  } catch (error) {
    yield put(getAdminUserRolesError(error))
  }
}

function* onCreateAdminUserRoles({ payload: { admin_users, history } }) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_roles`,
      {
        body: JSON.stringify(admin_users),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(createAdminUserRolesSuccess(response))
  } catch (error) {
    yield put(createAdminUserRolesError(error))
  }
}

function* onUpdateAdminUserRoles({ payload: { admin_users, history } }) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_roles/${admin_users.id}`,
      {
        body: JSON.stringify(admin_users),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(updateAdminUserRolesSuccess(response))
  } catch (error) {
    yield put(updateAdminUserRolesError(error))
  }
}

function* onDeleteAdminUserRoles(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_roles/${action.payload.id}`,
      { body: JSON.stringify({...action.payload}),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteAdminUserRolesSuccess(response))
    yield put(getAdminUserRoles())
  } catch (error) {
    yield put(deleteAdminUserRolesError(error))
  }
}

function* onAddNotificationTemplateToAdminRole(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_role/notification_template/${action.payload.admin_role_id}`,
      {
        body: JSON.stringify({admin_notification_template_id: action.payload.admin_notification_template_id}),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(addNotificationTemplateToAdminRoleSuccess(response))
  } catch (error) {
    yield put(addNotificationTemplateToAdminRoleError(error))
  }
}

function* adminUserRolesSaga() {
  yield takeEvery(GET_ADMIN_USER_ROLES, onGetAdminUserRoles)
  yield takeEvery(CREATE_ADMIN_USER_ROLE, onCreateAdminUserRoles)
  yield takeEvery(UPDATE_ADMIN_USER_ROLE, onUpdateAdminUserRoles)
  yield takeEvery(DELETE_ADMIN_USER_ROLE, onDeleteAdminUserRoles)
  yield takeEvery(ADD_NOTIFICATION_TEMPLATE_TO_ADMIN_ROLE, onAddNotificationTemplateToAdminRole)
}

export default adminUserRolesSaga;
